import { TID } from "@/lib/testIds";
import { motion } from "framer-motion";
import BuilderProjectsCarousel from "@/components/BuilderProjectsCarousel";
import Spotlight from "@/components/Spotlight";

const PILLARS = [
  { k: "01", t: "Reliability", d: "We hit programmed dates. Trades downstream stay scheduled." },
  { k: "02", t: "Capacity", d: "Two manufacturing floors. Volume that scales with your pipeline." },
  { k: "03", t: "Communication", d: "One project manager from drawings to final inspection." },
  { k: "04", t: "Quality control", d: "Every unit inspected before it leaves the factory." },
  { k: "05", t: "On-time delivery", d: "Just-in-time logistics for staged developments." },
  { k: "06", t: "Long-term partnerships", d: "Most builders we work with have stayed for 5+ years." },
];

export default function BuilderConfidence() {
  return (
    <section
      id="builder-confidence"
      data-testid={TID.builderConfidence.root}
      className="relative bg-charcoal text-cream py-28 md:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <p className="text-[11px] tracking-[0.32em] uppercase text-cream/60 mb-10">
          For builders & developers
        </p>
        <h2 className="font-display font-light text-[10vw] md:text-[5.4vw] leading-[0.98] tracking-tightest max-w-5xl">
          Built for projects of every scale.
        </h2>
        <p className="mt-8 max-w-xl text-cream/75 text-lg md:text-xl leading-relaxed">
          From a single custom home to a sixty-unit development. The same
          studio. The same standard.
        </p>

        <div className="mt-16 md:mt-20">
          <BuilderProjectsCarousel />
        </div>

        <div className="mt-28 md:mt-36 grid md:grid-cols-12 gap-y-12 md:gap-x-12">
          <div className="md:col-span-4">
            <p className="text-[11px] tracking-[0.32em] uppercase text-brass">
              Why builders stay
            </p>
            <h3 className="mt-6 font-display font-light text-3xl md:text-4xl leading-tight">
              Six things every builder needs from a joinery partner.
            </h3>
          </div>
          <ul className="md:col-span-8 md:pl-12 md:border-l border-cream/15 divide-y divide-cream/15">
            {PILLARS.map((p) => (
              <Spotlight
                key={p.k}
                as="li"
                tone="dark"
                radius={360}
                className="overflow-hidden"
              >
                <motion.div
                  data-testid={TID.builderConfidence.pillar}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.7 }}
                  className="relative py-7 grid grid-cols-12 gap-4 items-baseline px-2 md:px-4 -mx-2 md:-mx-4"
                >
                  <span className="col-span-2 md:col-span-1 font-display text-brass text-sm tracking-[0.22em]">
                    {p.k}
                  </span>
                  <h4 className="col-span-10 md:col-span-4 font-display text-xl md:text-2xl">
                    {p.t}
                  </h4>
                  <p className="col-span-12 md:col-span-7 text-cream/70 leading-relaxed">
                    {p.d}
                  </p>
                </motion.div>
              </Spotlight>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
